import React, { useEffect, useState } from 'react';

interface Props {
}

const Crosshair: React.FC<React.SVGProps<SVGSVGElement>> = (props)  => {

	return <svg version="1.1" {...props} xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" enableBackground="new 0 0 27.147 27.147"
  viewBox="0 0 27.147 27.147">
<g>
 <path d="M26.492,12.033h-1.646c-0.689-5.053-4.695-9.053-9.75-9.732l-0.004-1.648C15.091,0.293,14.896,0,14.652,0L12.49,0.002
   c-0.242,0-0.439,0.293-0.439,0.656l0.002,1.643c-5.051,0.68-9.058,4.682-9.748,9.732h-1.65C0.293,12.033,0,12.229,0,12.473v2.162
   c0,0.242,0.293,0.439,0.655,0.439h1.644c0.674,5.07,4.688,9.09,9.753,9.771l0.004,1.646c0,0.363,0.195,0.656,0.439,0.656
   l2.16-0.004c0.244,0,0.439-0.293,0.439-0.654v-1.645c5.066-0.68,9.084-4.701,9.756-9.771h1.641c0.363,0,0.656-0.197,0.656-0.439
   v-2.162C27.148,12.229,26.855,12.033,26.492,12.033z M18.115,15.074h2.629c-0.289,1.391-0.973,2.654-1.992,3.676
   c-1.02,1.02-2.283,1.701-3.678,1.99v-2.629c0-0.201-0.164-0.363-0.363-0.363h-2.273c-0.201,0-0.363,0.162-0.363,0.363v2.629
   c-1.393-0.289-2.658-0.971-3.676-1.99c-1.019-1.021-1.701-2.285-1.989-3.676h2.63c0.199,0,0.363-0.164,0.363-0.365v-2.271
   c0-0.201-0.164-0.365-0.363-0.365H6.41c0.288-1.389,0.971-2.654,1.989-3.674c1.02-1.021,2.284-1.705,3.676-1.992v2.631
   c0,0.199,0.162,0.361,0.363,0.361h2.273c0.199,0,0.363-0.162,0.363-0.361V6.406c1.393,0.287,2.658,0.971,3.678,1.992
   c1.02,1.02,1.703,2.285,1.992,3.674h-2.629c-0.201,0-0.363,0.164-0.363,0.365v2.271C17.751,14.91,17.914,15.074,18.115,15.074z"/>
 <g>
 </g>
 <g>
 </g>
 <g>
 </g>
 <g>
 </g>
 <g>
 </g>
 <g>
 </g>
 <g>
 </g>
 <g>
 </g>
 <g>
 </g>
 <g>
 </g>
 <g>
 </g>
 <g>
 </g>
 <g>
 </g>
 <g>
 </g>
 <g>
 </g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
<g>
</g>
</svg>
};

export {Crosshair};